/* eslint-disable */
import { RattanDoor, EleganceDoor } from './Elegance';

import { ModernDoor, GladernDoor } from './Modern';

import { AtelierDoor, LoftDoor, VerriereDoor } from './Industrial';

import { LaraDoor } from './Lara';

import { ForessoDoor, RedDotDoor } from './Minimalist';

import type { Object3D } from './Object3D';
import type { ResourceManager } from './ResourceManager';

export const ModelFactory = (
  type: string,
  attributes: Record<string, any>,
  render: () => void,
  maxAnisotropy: number,
  resourceManager: ResourceManager
): Object3D => {
  const types = {
    'atelier-style': AtelierDoor,
    'barndoor-style-1': EleganceDoor,
    'barndoor-style-2': EleganceDoor,
    'industrial-style': VerriereDoor,
    'loft-style': LoftDoor,
    'minimalist-style': ForessoDoor,
    'dot-style': RedDotDoor,
    // 'minimalist-style': RedDotDoor,
    // 'minimalist-style-2': ForessoDoor,
    'modern-style': ModernDoor,
    'gladern-style': GladernDoor,
    'rattan-style': RattanDoor,
    // 'modern-style': RattanOilDoor,
    // 'rattan-style-1': ModernDoor,
    'rustic-style-1': EleganceDoor,
    'rustic-style-2': EleganceDoor,
    'wardrobe-style': LaraDoor,
    'mirror-style': LaraDoor,
    'elegance-style': EleganceDoor,
  };

  const DoorModel = types[type];

  return DoorModel
    ? new DoorModel(attributes, render, maxAnisotropy, resourceManager)
    : new EleganceDoor(attributes, render, maxAnisotropy, resourceManager);
};

export const isMinimalist = (type: string): boolean => {
  const types = ['minimalist-style', 'dot-style', 'bamboo-style'];
  return types.includes(type);
};

export const isSystemHidden = (type: string): boolean => {
  const types = ['hidden', 'system-hidden-black', 'system-hidden-white'];
  return types.includes(type);
};

export const isSystemTop = (type: string): boolean => {
  const types = ['top', 'system-top-black', 'system-top-white'];
  return types.includes(type);
};

export const isDot = (type: string): boolean => {
  const types = ['dot-style'];
  return types.includes(type);
};
